import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_BASE_NAME } from './constants';
import type { MasterPartner } from '@/types/data';

export type MasterPartnersState = {
    masterPartners: MasterPartner[];
    isLoading: boolean;
    error: string | null;
};

const initialState: MasterPartnersState = { masterPartners: [], isLoading: false, error: null };

const masterPartnersSlice = createSlice({
    name: `${SLICE_BASE_NAME}/masterPartners`,
    initialState,
    reducers: {
        setMasterPartners: (state, action: PayloadAction<MasterPartner[]>) => { state.masterPartners = action.payload; },
        setLoading: (state, action: PayloadAction<boolean>) => { state.isLoading = action.payload; },
        setError: (state, action: PayloadAction<string | null>) => { state.error = action.payload; },
    },
});

export const { setMasterPartners, setLoading, setError } = masterPartnersSlice.actions;
export default masterPartnersSlice.reducer;
